import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { popModal, hasOpenModal } from '../utils/modalStack';

export function useBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let handler;
    import('@capacitor/app').then(({ App }) => {
      handler = App.addListener('backButton', () => {
        // If a modal/sheet is open, close it instead of navigating
        if (hasOpenModal()) {
          popModal();
          return;
        }
        if (location.pathname === '/home') {
          App.exitApp();
        } else {
          navigate(-1);
        }
      });
    });

    return () => {
      if (handler) handler.then?.(h => h?.remove());
    };
  }, [navigate, location.pathname]);
}
